<template>
<el-dialog :title=" '查看'" :close-on-click-modal="false" width="90%" :visible.sync="viewData.visible">
    <!-- <H1 style="text-align:center">北京汽车制造厂（青岛）有限公司</H1> -->
    <el-tabs>
        <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmit()" label-width="0px" size="small" class="org-dialog-form">
            <div class="des_box">
                <el-descriptions class="margin-top" :column="3" size="small" border style="margin-bottom: 15px;">
                    <el-descriptions-item label="结算单号:" :label-style="getStyle()" :content-style="getStyle2()">
                        <el-form-item prop="zjsdh" style="margin-bottom: 0;">
                            <span>{{dataForm.zjsdh}}</span>
                        </el-form-item>
                    </el-descriptions-item>
                    <el-descriptions-item label="供应商代码:" :label-style="getStyle()" :content-style="getStyle2()">
                        <el-form-item prop="lifnr" style="margin-bottom: 0;">
                            <span>{{dataForm.lifnr}}</span>
                        </el-form-item>
                    </el-descriptions-item>
                    <el-descriptions-item label="供应商名称:" :label-style="getStyle()" :content-style="getStyle2()">
                        <el-form-item prop="name1" style="margin-bottom: 0;">
                            <span>{{dataForm.name1}}</span>
                        </el-form-item>
                    </el-descriptions-item>
                    <el-descriptions-item label="结算单类型:" :label-style="getStyle()" :content-style="getStyle2()">
                        <el-form-item prop="ztype" style="margin-bottom: 0;">
                            <span>{{accountTypeFormat(dataForm.ztype)}}</span>
                        </el-form-item>
                    </el-descriptions-item>
                    <el-descriptions-item label="工厂:" :label-style="getStyle()" :content-style="getStyle2()">
                        <el-form-item prop="werks" style="margin-bottom: 0;">
                            <span>{{dataForm.werks}}</span>
                        </el-form-item>
                    </el-descriptions-item>
                    <el-descriptions-item label="工厂名称:" :label-style="getStyle()" :content-style="getStyle2()">
                        <el-form-item prop="name2" style="margin-bottom: 0;">
                            <span>{{dataForm.name2}}</span>
                        </el-form-item>
                    </el-descriptions-item>
                    <el-descriptions-item label="开票通知日期:" :label-style="getStyle()" :content-style="getStyle2()">
                        <el-form-item prop="zkptzrq" style="margin-bottom: 0">
                            <span>{{dateFormat1(dataForm.zkptzrq)}}</span>
                        </el-form-item>
                    </el-descriptions-item>
                    <el-descriptions-item label="发布日期时间:" :label-style="getStyle()" :content-style="getStyle2()">
                        <el-form-item prop="zpub" style="margin-bottom: 0">
                            <span>{{datTimeFormat(dataForm.zpub)}}</span>
                        </el-form-item>
                    </el-descriptions-item>
                     <el-descriptions-item label="含税总金额:" :label-style="getStyle()" :content-style="getStyle2()">
                        <el-form-item prop="zhszje" style="margin-bottom: 0;">
                            <span v-if="viewFlag === 'view'">{{dataForm.zhszje}}</span>
                            <el-input v-else v-model="dataForm.zhszje" placeholder="含税总金额" size="small"></el-input>
                        </el-form-item>
                    </el-descriptions-item>
                    <el-descriptions-item label="结算起始日期:" :label-style="getStyle()" :content-style="getStyle2()">
                        <el-form-item prop="zbadutl" style="margin-bottom: 0">
                            <span>{{dateFormat1(dataForm.zbadutl)}}</span>
                        </el-form-item>
                    </el-descriptions-item>
                    <el-descriptions-item label="结算终止日期:" :label-style="getStyle()" :content-style="getStyle2()">
                        <el-form-item prop="zbaduth" style="margin-bottom: 0">
                           <span>{{dateFormat1(dataForm.zbaduth)}}</span>
                        </el-form-item>
                    </el-descriptions-item>
                    <el-descriptions-item label="不含税总金额:" :label-style="getStyle()" :content-style="getStyle2()">
                        <el-form-item prop="zbhszje" style="margin-bottom: 0;">
                            <span>{{dataForm.zbhszje}}</span>
                        </el-form-item>
                    </el-descriptions-item>
                </el-descriptions>
            </div>
        </el-form>
        
        <!-- <el-row style="margin-bottom:0">
            <el-col :span="24">
                <el-button style="margin-left:15px" size="small" v-if="isAuth('sourcing:settlement:newbutton') && viewFlag !== 'view'" type="primary" @click="addOrUpdateAccountPartHandle()" icon="el-icon-plus" :disabled="!dataForm.id" class="mb15 fr">
                    新增
                </el-button>
            </el-col>
        </el-row> -->
        <el-table :data="accountPartList" row-key="id" size="small" border style="width: 100%;" :default-expand-all="false" :header-cell-style="{background:'#f5f5f5'}">
            <el-table-column type="index" width="50" label="序号">
                <template slot-scope="scope">
                    {{ scope.$index + 1 + (pageIndex - 1) * pageSize }}
                </template>
            </el-table-column>
            <!-- <el-table-column prop="zjsdh" header-align="center" align="left" label="结算单号" width="150">
            </el-table-column> -->
            <el-table-column prop="belnr" header-align="center" align="center" label="物料凭证" width="100">
            </el-table-column>
            <!-- <el-table-column prop="buzei" header-align="center" align="left" label="项目" width="150">
            </el-table-column> -->
            <el-table-column prop="matnr" header-align="center" align="center" label="物料编码" width="100">
            </el-table-column>
            <el-table-column prop="txz01" header-align="center" align="center" label="物料描述" width="100">
            </el-table-column>
            <el-table-column prop="ekorg" header-align="center" align="center" label="采购组织" width="100">
            </el-table-column>
            <!-- <el-table-column prop="ekotx" header-align="center" align="center" label="采购组织名称" width="150">
            </el-table-column> -->
            <el-table-column prop="ekgrp" header-align="center" align="center" label="采购组" width="80">
            </el-table-column>
            <el-table-column prop="eknam" header-align="center" align="center" label="采购组名称" width="100">
            </el-table-column>
            <el-table-column prop="meins" header-align="center" align="center" label="单位" width="50">
                <template slot-scope="scope">
                    <span>{{getUnitName(scope.row.meins)}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="zmenge" header-align="center" align="center" label="数量" width="50">
            </el-table-column>
            <el-table-column prop="zkpsl" header-align="center" align="center" label="开票数量" width="80">
            </el-table-column>
            <el-table-column prop="logrt" header-align="center" align="center" label="库存地点" width="100">
            </el-table-column>
            <el-table-column prop="lgobe" header-align="center" align="center" label="库存地点名称" width="100">
            </el-table-column>
            <el-table-column prop="znetpr" header-align="center" align="center" label="价格" width="100">
            </el-table-column>
            <el-table-column prop="mwskz" header-align="center" align="center" label="税码" width="100">
                <template slot-scope="scope">
                    <span>{{getTaxCodeName(scope.row.mwskz)}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="wrbtr" header-align="center" align="center" label="金额" width="100">
            </el-table-column>
            <!-- <el-table-column fixed="right" v-if="viewFlag !== 'view'" header-align="center" align="left" width="140" label="操作">
                <template slot-scope="scope">
                    <el-button type="text" size="small" @click="addOrUpdateAccountPartHandle(scope.row.id)" icon="el-icon-edit">
                        修改
                    </el-button>
                    <el-button type="text" size="small" @click="deleteHandleAccountPart(scope.row.id)" icon="el-icon-delete" class="button-danger">
                        删除
                    </el-button>
                </template>
            </el-table-column> -->
        </el-table>
        <el-pagination @size-change="sizeChangeHandle" @current-change="currentChangeHandle" :current-page="pageIndex" :page-sizes="[10, 20, 50]" :page-size="pageSize" :total="totalPage" layout="total, sizes, prev, pager, next, jumper" class="mb15">
        </el-pagination>
        <el-row :gutter="40">
            <!-- <el-col :span="24" style="text-align:right;">
                <el-button size="small" @click="viewData.visible = false">
                    取消
                </el-button>
                <el-button size="small" type="primary" @click="dataFormSubmit()">
                    提交
                </el-button>
                <el-button size="small" type="danger" @click="dataFormSubmit()">
                    冻结
                </el-button>
                <el-button size="small" type="success" @click="dataFormSubmit()">
                    生成编码
                </el-button>
            </el-col> -->
        </el-row>
    </el-tabs>
    <!-- 弹窗, 新增 / 修改 零件-->
    <add-or-update-account-part v-if="addOrUpdateAccountPartVisible" ref="addOrUpdateAccountPart" @refreshAccountPartDataList="listPart"></add-or-update-account-part>
</el-dialog>
</template>

<script>
import {
    edit,
    add,
    listPart,
    deletePartBatch,
    queryById,
} from '@/controller/settlement'
import AddOrUpdateAccountPart from "./account-part-add-or-update";
import {
    getLabelByValue,
    ACCOUNT_TYPE_VALUE,
} from '@/utils/const'
import {
    getFactoryList,
    getUnitList,
    getTaxCodeList
} from '@/controller/systemData'
import moment from 'moment'
export default {
    data() {
        return {
            viewData: {
                visible: false,
                width: ''
            },
            viewFlag: '',
            dataList: [],
            getLabelByValue: getLabelByValue,
            ACCOUNT_TYPE_VALUE: ACCOUNT_TYPE_VALUE,
            accountPartList: [],
            addOrUpdateAccountPartVisible: false,
            factoryList: [],
            unitList: [],
            taxCodeList: [],
            pageIndex: 1,
            pageSize: 10,
            totalPage: 0,
            dataForm: {
                id: 0,
                lifnr: '',
                name1: '',
                zjsdh: '',
                zkptzrq: '',
                zhszje: '',
                zbhszje: '',
                werks: '',
                name2: '',
                ztype: '',
                zpub: '',
                payDate: ''
            },
            dataRule: {
                // name: [
                //     { required: true, message: '组织名称不能为空', trigger: 'blur' }
                // ],
                // code: [
                //     { required: true, message: '组织代码不能为空', trigger: 'blur' }
                // ],
                // tenantName: [
                //     { required: true, message: '请先在页面顶部导航栏选择租户', trigger: 'blur' }
                // ]
            }
        }
    },
    components: {
        AddOrUpdateAccountPart
    },
    mounted() {},
    methods: {
        // 新增 / 修改 零件表
        addOrUpdateAccountPartHandle(id) {
            this.addOrUpdateAccountPartVisible = true;
            this.$nextTick(() => {
                this.$refs.addOrUpdateAccountPart.init(
                    id,
                    this.dataForm.id
                );
            });
        },
        // 每页数
        sizeChangeHandle(val) {
            this.pageSize = val;
            this.pageIndex = 1;
            this.listPart();
        },
        // 当前页
        currentChangeHandle(val) {
            this.pageIndex = val;
            this.listPart();
        },
        // 多选
        selectionChangeHandle(val) {
            this.dataListSelections = val;
        },
        // 删除零件
        deleteHandleAccountPart(id) {
            let ids = id ? [id] :
                this.dataListSelections.map((item) => {
                    return item.id;
                });
            this.$confirm(`确定进行删除操作?`, "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                .then(() => {
                    deletePartBatch(ids)
                        .then((data) => {
                            if (data && data.code === "00") {
                                this.$message({
                                    message: "操作成功",
                                    type: "success",
                                    duration: 1500,
                                    onClose: () => {
                                        this.listPart();
                                    },
                                });
                            } else {
                                this.$message.error(data.msg);
                            }
                        })
                        .catch((error) => {
                            console.log(error);
                        });
                })
                .catch(() => {});
        },
        init(data, id, viewFlag) {
            console.log(data)
            // this.dataForm = data ? data : this.dataForm
            this.dataForm.id = id || 0
            this.accountPartList = [];
            this.viewData.visible = true
            this.viewFlag = viewFlag;
            this.$nextTick(() => {
                this.$refs['dataForm'].resetFields()
                // this.dataForm.tenantName = sessionStorage.getItem('tenantName')
                if (this.dataForm && this.dataForm.id) {
                    queryById({}, this.dataForm.id).then(data => {
                        if (data && data.code === '00') {
                            this.dataForm = data.body
                        }
                        this.listPart();
                    });
                }
                this.getFactoryList()
                this.getUnitList()
                this.getTaxCodeList()
            })
        },
        //获取工厂数据
        getFactoryList() {
            getFactoryList({
                post: "",
                address: "",
                factoryDesc: "",
                factoryCode: ""
            }).then(data => {
                if (data && data.code === '00') {
                    this.factoryList = data.body;
                }
            })
        },
        getUnitList() {
            getUnitList({
                code: "",
                name: "",
            }).then(data => {
                if (data && data.code === '00') {
                    this.unitList = data.body;
                }
            });
        },
        getTaxCodeList() {
            getTaxCodeList({
                taxCode: "",
                taxRate: "",
            }).then(data => {
                if (data && data.code === '00') {
                    this.taxCodeList = data.body;
                }
            });
        },
        getUnitName(code) {
            const unit = this.unitList.find(unit => unit.code === code)
            return unit ? unit.name : ''
        },

        // 查所有订单零件表
        listPart() {
            listPart({
                zjsdh: this.dataForm.zjsdh,
                pageNo: this.pageIndex,
                pageSize: this.pageSize,
            }).then((data) => {
                if (data && data.code === "00") {
                    console.log(data)
                    this.accountPartList = data.body.records;
                    this.totalPage = data.body.total;
                    console.log(this.accountPartList)
                } else {
                    this.accountPartList = [];
                    this.totalPage = 0;
                }
            });
        },
        dateFormat: function (row, column) {
            var date = row[column.property]
            if (date == undefined) {
                return ''
            }
            return moment(date).format("YYYY-MM-DD")
        },
        // 表单提交
        dataFormSubmit() {
            this.$refs['dataForm'].validate((valid) => {
                let params = this.dataForm
                if (valid) {
                    // debugger
                    if (this.dataForm.id) {
                        edit(params).then(data => {
                            if (data && data.code === '00') {
                                // this.dataForm = data.body;
                                this.$message({
                                    message: '操作成功',
                                    type: 'success',
                                    onClose: () => {
                                        this.$emit('refreshDataList')
                                    }
                                })
                            } else {
                                this.$message.error(data.msg)
                            }
                        })
                    } else {
                        add(params).then(data => {
                            if (data && data.code === '00') {
                                this.dataForm.id = data.body ? data.body.id : '';
                                this.$message({
                                    message: '操作成功',
                                    type: 'success',
                                    onClose: () => {
                                        this.$emit('refreshDataList')
                                    }
                                })

                            } else {
                                this.$message.error(data.msg)
                            }
                        })
                    }
                }
            })
        },
        accountTypeFormat: function (value) {
            if (!value) {
                return ''
            }
            return getLabelByValue(ACCOUNT_TYPE_VALUE, value)
        },
        setFactoryName(val) {
            console.log(val)
            const factory = this.factoryList.find(factory => factory.factoryCode === val)
            this.dataForm.name2 = factory ? factory.factoryDesc : ''
        },
        dateFormat1(date) {
            return moment(date).format("YYYY-MM-DD")
        },
        datTimeFormat(date) {
            return moment(date).format("YYYY-MM-DD HH:mm:ss")
        },
        // 获取税码的名字
        getTaxCodeName(code) {
            const taxCode = this.taxCodeList.find(taxCode => taxCode.taxCode === code)
            return taxCode ? taxCode.taxRate : ''
        },
        getStyle() {
            return 'width: 120px; text-align: right'
        },
        getStyle2() {
            return 'width: 392px;'
        }
    }
}
</script>
